export default "__VITE_ASSET__C2Dq5mWv__"